import { render, staticRenderFns } from "./rlp-site-map.vue?vue&type=template&id=5b511211&scoped=true&"
import script from "./js/rlp-site-map.js?vue&type=script&lang=js&"
export * from "./js/rlp-site-map.js?vue&type=script&lang=js&"
import style0 from "./rlp-site-map.vue?vue&type=style&index=0&id=5b511211&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b511211",
  null
  
)

export default component.exports